/* ADD POLL */
export const LIST_POLL_ANSWER = "LIST_POLL_ANSWER"
export const LIST_POLL_ANSWER_SUCCESS = "LIST_POLL_ANSWER_SUCCESS"
export const LIST_POLL_ANSWER_CLEAN = "LIST_POLL_ANSWER_CLEAN"
export const LIST_POLL_ANSWER_ERROR = "LIST_POLL_ANSWER_ERROR"
